import { useAuth } from "../contexts/AuthContext";

export const useAuthorisation = () => {
  const { getAccessToken, signIn, ...rest } = useAuth();

  const getAccessTokenOrSignIn = async () => {
    try {
      // First check for wallet token (if wallet is connected)
      const walletToken = localStorage.getItem("pentatonic_wallet_token");
      if (walletToken) {
        console.log("[useAuthorisation] Using wallet token for authentication");
        return walletToken;
      }

      // Fall back to WorkOS session token
      const sessionToken = await getAccessToken();
      if (sessionToken) {
        return sessionToken;
      }

      // No auth available, redirect to sign in
      console.error(
        "No session token found, redirect to signing in, return to",
        window.location.pathname
      );
      localStorage.setItem("returnTo", window.location.pathname);
      await signIn();

      return false;
    } catch (error) {
      console.error("[useAuthorisation] Error getting token:", error);
      localStorage.setItem("returnTo", window.location.pathname);
      await signIn();
      return false;
    }
  };

  return {
    getAccessTokenOrSignIn,
    ...rest,
  };
};
